import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { useSmartviewManager } from '@morningtrain/react-smartviews'
import { HandleOuterClicksContext } from 'services/HandleOuterClicks'

function SmartviewSidebar (props) {
  const smartviewManager = useSmartviewManager()
  const wrapperRef = React.createRef()
  const innerWrapperRef = React.createRef()

  const handleClickOutside = (event) => {
    if (props.ghost === true) {
      return
    }

    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      smartviewManager.handleClickOutside()
    }
  }

  const handleOuterClicksContext = React.useContext(HandleOuterClicksContext)

  React.useEffect(() => {
    handleOuterClicksContext.onClick(handleClickOutside)

    return () => {
      handleOuterClicksContext.removeOnClick(handleClickOutside)
    }
  })

  const currentSize = smartviewManager.config.get('size')
  const [size, setSize] = React.useState(props.defaultSmartviewSize || 'xs')

  React.useEffect(() => {
    if (size !== currentSize) {
      setSize(currentSize)
    }
  })

  const innerWrapperClassNames = [
    'transform',
    'transition-width',
    'ease-in-out',
    'duration-500',
    'sm:duration-700'
  ]

  /// Keep this to not have tailwind purge them
  const availableSizes = [
    'w-xs',
    'w-sm',
    'w-md',
    'w-lg',
    'w-xl',
    'w-2xl',
    'w-3xl',
    'w-4xl',
    'w-5xl',
    'w-6xl'
  ]

  const innerWrapperClassName = innerWrapperClassNames.join(' ')

  function generateSizeClass () {
    if (size) {
      return 'w-' + size
    }

    if (currentSize) {
      return 'w-' + currentSize
    }

    return null
  }

  React.useEffect(() => {
    const element = innerWrapperRef.current

    if (element) {
      const sizeClass = generateSizeClass()
      const innerWrapperClassNameWithSize = innerWrapperClassName + ' ' + sizeClass

      if (element.className !== innerWrapperClassNameWithSize) {
        if (innerWrapperRef.current.classList && innerWrapperRef.current.classList.add) {
          ([].slice.call(innerWrapperRef.current.classList)).forEach(className => {
            if (innerWrapperClassNames.indexOf(className) === -1) {
              innerWrapperRef.current.classList.remove(className)
            }
          })

          innerWrapperRef.current.classList.add(sizeClass)
        } else {
          innerWrapperRef.current.className = innerWrapperClassNameWithSize
        }
      }
    }
  }, [size])

  return (
    <section ref={wrapperRef} className={(props.ghost === true ? 'relative' : 'absolute border-l border-gray-200') + ' inset-y-0 right-0 max-w-full flex'}>
      <div ref={innerWrapperRef} className={innerWrapperClassName + ' ' + generateSizeClass()}>
        <div className='h-full flex flex-col pt-12 pb-8 bg-white overflow-y-auto xl:pt-14 xl:pb-12'>
          {props.children}
        </div>
      </div>
    </section>
  )
};

SmartviewSidebar.defaultProps = {
  ghost: false,
  defaultSmartviewSize: null
}

SmartviewSidebar.propTypes = {
  ghost: PropTypes.bool,
  defaultSmartviewSize: PropTypes.string
}

export default observer(SmartviewSidebar)
